<template>
  <div class="bg-gray90 c-white">
    <div class="p-y-6">
      <div class="container p-x-2:mo">
        <div class="layout gap-2">
          <div class="layout-item is-12 is-4:t">
            <div class="m-b-4:t" selenium="company-title">COMPANY</div>
            <div>
              <router-link :to="{ name: 'about' }" class="FOOTER-LINK" selenium="about-link">
                About
              </router-link>
            </div>
            <div>
              <a
                  class="FOOTER-LINK"
                  href="https://careers.homedepot.com/career-areas/technology-careers/"
                  target="_blank"
                  rel="noopener noreferrer"
                  selenium="careers-link">
                Careers
              </a>
            </div>
            <div>
              <router-link
                  :to="{ name: 'about::contact'}"
                  class="FOOTER-LINK"
                  selenium="contact-us-link">
                Contact Us
              </router-link>
            </div>
          </div>
          <div class="layout-item is-12 is-4:t">
            <div class="m-b-4:t" selenium="pro-center-title">PRO CENTER</div>
            <div>
              <a
                  :href="this.$runtimeConstants.SALESFORCE_BECOME_A_PRO"
                  class="FOOTER-LINK"
                  selenium="become-a-pro-link">
                Become A Pro
              </a>
            </div>
            <div>
              <a
                  :href="this.$runtimeConstants.SALESFORCE_HELP_CENTER"
                  target="_blank"
                  class="FOOTER-LINK"
                  rel="noopener noreferrer"
                  selenium="footer-help-center-link">
                Help Center
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer-upper',
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
.FOOTER-LINK {
  color: #EDEDED;
}
</style>
